import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';


import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../core/data-access/app.service';
import { UserPermission } from '../../../users/ model/user.model';
import { AuthService } from '../../auth/services/auth.service';
import { HasRoleDirective } from '../../directives/hasRole.directive';
import { UserMenuButtonComponent } from '../user-menu-button/user-menu-button.component';

interface MenuItem {
  label: string;
  icon: string;
  route: string;
  routeOptions?: { exact: boolean };
  permissions?: UserPermission[];
}

@Component({
    selector: 'app-main-layout',
    imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    HasRoleDirective,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    MatSlideToggleModule,
    UserMenuButtonComponent,
    CommonModule,
    MatTooltipModule
],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  /** Whether the side menu is open */
  public isSidenavOpen$ = this.appService.isSidenavOpen$;
  /** Active app theme */
  public theme$ = this.appService.theme$;
  /** Logged in user */
  public user$ = this.authService.user$;
  /** Side nav mode */
  public sideNavMode$: WritableSignal<MatDrawerMode> = signal('side');
  /** App Version number */
  public appVersion: string = environment.version;

  authServices = inject(AuthService);

  /** Items to show in side menu */
  public menuItems: MenuItem[] = [
    {
      label: 'Home',
      icon: 'home',
      route: '/',
      routeOptions: { exact: true }
    },
    {
      label: 'Request to Purchase (RTP)',
      icon: 'money',
      route: '/home/createdashboard',
      routeOptions: { exact: true }
    },
    {
      label: 'Purchase Order (PO)',
      icon: 'receipt',
      route: '/home/createpo',
      routeOptions: { exact: true }
    },

    // { label: 'Installations', icon: 'domain', route: 'installations', permissions: [UserPermission.InstallationRead] },
    // { label: 'Admin', icon: 'corporate_fare', route: 'admin', permissions: [UserPermission.InstallationDelete] },
    // { label: '- Event Editor', icon: '', route: '/admin/event-editor', permissions: [UserPermission.InstallationDelete] },
    // { label: '- Event Options', icon: '', route: '/admin/event-options', permissions: [UserPermission.InstallationDelete] },
    // { label: '- Baseline Options', icon: '', route: 'admin/baseline-options', permissions: [UserPermission.InstallationDelete] },
    // { label: '- RTP Editor', icon: '', route: 'admin/rtp-editor', permissions: [UserPermission.InstallationDelete] },
    
    // { label: 'Request To Purchase', icon: 'description', route: 'rtp', permissions: [UserPermission.RtpEdit] },
    // { label: 'Tasks', icon: 'task', route: 'tasks' },
    // { label: 'Warehouses', icon: 'building', route: 'warehouses', permissions: [UserPermission.WarehouseRead] },
    // {
    //   label: 'Software Licenses',
    //   icon: 'military_tech',
    //   route: 'software-licenses',
    //   permissions: [UserPermission.SoftwareLicenseRead]
    // },
    {
      label: 'Contract Data Req. List (CDRL)',
      icon: 'summarize',
      route: 'cdrls',
      permissions: [UserPermission.CDRLRead]
    },
    {
      label: 'Admin Console',
      icon: 'bug_report',
      route: '/home/adminconsole',
      routeOptions: { exact: true }
    },
    // { label: 'Users', icon: 'person', route: 'users', permissions: [UserPermission.UserRead] },
    // { label: 'Roles/Permissions', icon: 'group', route: 'roles', permissions: [UserPermission.UserRead] },
    { label: 'My Settings', icon: 'settings', route: 'settings' },
    { label: 'Support', icon: 'support', route: 'support' }
  ];

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .pipe(takeUntilDestroyed())
      .subscribe(result => {
        this.sideNavMode$.set(result.matches ? 'over' : 'side');
        this.appService.toggleSideNav(!result.matches);
      });
  }

  /**
   * Show/hide side menu
   */
  onToggleSidenav(): void {
    this.appService.toggleSideNav(!this.appService.isSidenavOpen$());
  }

  /**
   * Handle side nav open event
   * @param e open changed event
   */
  onNavOpenChange(isOpen: boolean): void {
    this.appService.toggleSideNav(isOpen);
  }

  /**
   * Change app theme
   * @param event toggle event
   */
  onToggleTheme(): void {
    this.appService.changeTheme(this.appService.theme$() === 'light' ? 'dark' : 'light');
  }
}
